@use '../@shared/global' as *;
@use '../@shared/alert.mixin' as *;
@use '../@shared/form-field.mixin' as *;
@use '../@shared/input-container.mixin' as *;
@use '../@shared/input.mixin' as *;
@use '../@shared/mixins' as *;

@layer kol-component {
	@include kol-alert;
	@include kol-form-field;
	@include kol-input-container;
	@include kol-input;
}
